import { render, staticRenderFns } from "./PartnerType.vue?vue&type=template&id=6dd95146&"
import script from "./PartnerType.vue?vue&type=script&lang=js&"
export * from "./PartnerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports